// utils/dateUtils.js

/**
 * Get the start of the week (Sunday) for a given date.
 * Returns a Date object with time cleared to 00:00:00.
 */
export function getStartOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay(); // 0 (Sun) to 6 (Sat)
  d.setDate(d.getDate() - day); // Go back to Sunday
  d.setHours(0, 0, 0, 0); // Remove time
  return d;
}

/**
 * Formats a date input (Date object or string) into a localized date string.
 * Handles plain "YYYY-MM-DD" strings as local dates.
 *
 * @param {Date|string} date - The date to format.
 * @param {string} [locale='en-US'] - Optional locale for formatting.
 * @returns {string} - Formatted date string.
 */
export const formatDate = (date, locale = "en-US") => {
  let d;

  if (typeof date === "string") {
    // Treat plain "YYYY-MM-DD" as a local date (no timezone shift)
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [y, m, day] = date.split("-").map(Number);
      d = new Date(y, m - 1, day);
    } else {
      d = new Date(date);
    }
  } else if (date instanceof Date) {
    d = date;
  } else {
    throw new Error("Invalid date input. Must be a Date object or string.");
  }

  return d.toLocaleDateString(locale);
};
/**
 * Format a Date object to "YYYY-MM-DD"
 * Always uses local time, no timezone or UTC involved.
 */
export function formatDateLocal(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${month}/${day}/${year}`;
}
export const formatDateLocal_TF = (dateString) => {
  if (!dateString) {
    console.warn("formatDateLocal: Received empty or null dateString");
    return "";
  }
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.error("formatDateLocal: Invalid date string:", dateString);
      return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("formatDateLocal: Error formatting date:", dateString, error);
    return "";
  }
};

/**
 * Get the date string (YYYY-MM-DD) for a given offset from weekStart (Sunday).
 * `weekStart` should be a Date object already normalized by getStartOfWeek().
 */
export function getDateByDayOffset(weekStart, offset) {
  const d = new Date(weekStart);
  d.setDate(d.getDate() + offset);
  return formatDateLocal(d);
}

// This function takes a starting date and returns a string representing the date range of that week (7 days)
export function formatDateRange(startDate) {
  const start = new Date(startDate);
  const end = new Date(startDate);
  end.setDate(start.getDate() + 6);
  // Helper function to format a date object as 'YYYY/MM/DD'
  const format = (d) =>
    `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
      d.getDate()
    ).padStart(2, "0")}/${d.getFullYear()}`;
  // Return a string representing the full date range, e.g., '01/09/2023 - 07/09/2023'
  return `${format(start)} - ${format(end)}`;
}

// Format a date-time string to "MM/DD/YYYY, HH:MM AM/PM" US format
export function formatDateTimeUS(dateString) {
  if (!dateString) return "—";

  const date = new Date(dateString);
  console.log("formatDateTimeUS dateString:", dateString);
  console.log("formatDateTimeUS date:", date);

  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  console.log("toLocaleString:", date.toLocaleString("en-US", options));
  return date.toLocaleString("en-US", options); // -> MM/DD/YYYY, hh:mm AM/PM
}
